export default __webpack_public_path__ + "static/media/representatives_content_bg.f056a535.svg";